<div #body class="flex flex-row flex-1 page-content h-full">
  <mealcheck-informations-band
    class="h-full bb-qdm"
    (onPreferencesOpenRequest)="this.showSettingsModal = true"
  />

  <div class="flex-1 h-full bg-gris-4 p-4">
    <router-outlet></router-outlet>
  </div>
</div>

@if (this.showSettingsModal) {
  <app-modal-user-preferences (requestClose)="this.showSettingsModal = false" />
}

<app-sync-processing-overlay />
